import { gql, TypedDocumentNode } from '@apollo/client';

import {
  TaskLocation,
  TaskLocationAutocomplete,
  TaskLocationCreateInput,
  TaskLocationFind,
  TaskLocationsConnection,
  TaskLocationsConnectionInput,
  TaskLocationSimpleInput,
  TaskLocationUpdateInput,
} from '@atom/types/taskLocation';

export const BASE_TASK_LOCATION = gql`
  fragment BaseTaskLocation on TaskLocation {
    id
    workOrderId
    taskId
    name
    geometry
    data {
      title
      dataType
      enumeration
      value
    }
    createdDate
    createdBy
    updatedDate
    updatedBy
  }
`;

export const GET_TASK_LOCATIONS: TypedDocumentNode<
  { taskLocations: TaskLocationsConnection },
  { input: TaskLocationsConnectionInput }
> = gql`
  query taskLocations($input: TaskLocationsConnectionInput!) {
    taskLocations(input: $input) {
      totalCount
      taskLocations {
        ...BaseTaskLocation
      }
    }
  }
  ${BASE_TASK_LOCATION}
`;

export const TASK_LOCATION_CREATE: TypedDocumentNode<
  { taskLocationCreate: TaskLocation },
  { input: TaskLocationCreateInput }
> = gql`
  mutation taskLocationCreate($input: TaskLocationCreateInput!) {
    taskLocationCreate(input: $input) {
      ...BaseTaskLocation
    }
  }
  ${BASE_TASK_LOCATION}
`;

export const TASK_LOCATION_DUPLICATE: TypedDocumentNode<
  { taskLocationDuplicate: TaskLocation },
  { id: string }
> = gql`
  mutation taskLocationDuplicate($id: ID!) {
    taskLocationDuplicate(id: $id) {
      ...BaseTaskLocation
    }
  }
  ${BASE_TASK_LOCATION}
`;

export const TASK_LOCATION_UPDATE: TypedDocumentNode<
  { taskLocationUpdate: TaskLocation },
  { input: TaskLocationUpdateInput }
> = gql`
  mutation taskLocationUpdate($input: TaskLocationUpdateInput!) {
    taskLocationUpdate(input: $input) {
      ...BaseTaskLocation
    }
  }
  ${BASE_TASK_LOCATION}
`;

export const TASK_LOCATION_DELETE: TypedDocumentNode<
  { taskLocationDelete: boolean },
  { id: string }
> = gql`
  mutation taskLocationDelete($id: ID!) {
    taskLocationDelete(id: $id)
  }
`;

export const TASK_LOCATION_DATA_AUTOCOMPLETE: TypedDocumentNode<
  { taskLocationDataAutocomplete: TaskLocationAutocomplete },
  { input: TaskLocationSimpleInput }
> = gql`
  mutation taskLocationDataAutocomplete($input: TaskLocationSimpleInput!) {
    taskLocationDataAutocomplete(input: $input) {
      components {
        title
        dataType
        enumeration
        value
      }
      minMilePost
      maxMilePost
    }
  }
`;

export const TASK_LOCATION_FIND: TypedDocumentNode<
  { taskLocationFind: TaskLocationFind },
  { input: TaskLocationSimpleInput }
> = gql`
  mutation taskLocationFind($input: TaskLocationSimpleInput!) {
    taskLocationFind(input: $input) {
      name
      geometry
    }
  }
`;
